import axios from 'axios';
import React, { useState } from 'react';
import { Modal, Button, ModalHeader, ModalFooter } from "react-bootstrap";
const Swal = require('sweetalert2')
const EmailRestAPI = ({ showModal, handleClose }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

   
    const serviceId = 'service_q69g1hh';
    const templateId = 'template_cfckw6t';
    const publicKey = 'zPNqbOBFFMMm5mmeX';

    const data = {
      service_id: serviceId,
      template_id: templateId,
      user_id: publicKey,
      template_params: {
        from_name: name,
        from_email: email,
        to_name: 'dear',
        message: message,
      }
    };

  
    try {
      const res = await axios.post("https://api.emailjs.com/api/v1.0/email/send", data);
      console.log(res.data);
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 800,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    Toast.fire({
        icon: 'success',
        title: 'Mail sended'
    })
      setName('');
      setEmail('');
      setMessage('');
      handleClose(); 
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <Modal show={showModal} onHide={handleClose} className="modal-size md modal-top-center" style={{ display: "flex" }}>
      <Modal.Header >
        <Modal.Title>New Message</Modal.Title>


        <Button
          variant="secondary"
          onClick={handleClose}
          style={{
            backgroundColor: 'transparent', 
            border: 'none', 
            color: 'black', 
            padding: '0', 
            fontSize: '1rem', 
            lineHeight: '1', 
          }}
        >
          X
        </Button>

      </Modal.Header>
      <Modal.Body className="css">
        <form onSubmit={handleSubmit} >
          <div className='col-md-12'>
            <input
              className='form-control'
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className='col-md-12'>
            <input
              className='form-control'
              type="email"
              placeholder="Email Id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className='col-md-12'>
            <textarea
              className='form-control'
              cols="30"
              rows="10"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>
          <div className='col-md-12'><button className='btn btn-primary' type="submit">Send</button></div>

        </form>
      </Modal.Body>
      <Modal.Footer>

      </Modal.Footer>
    </Modal>
  );
}

export default EmailRestAPI;
